<template>

	<div class="user-section-heading">My Referrals</div>

	<MyReferralDashboard class="my-7" />

	<MyReferralList />

</template>



<script setup>

import MyReferralList from '@/components/Referral/MyReferrals/MyReferral-List.vue'
import MyReferralDashboard from '@/components/Referral/MyReferrals/MyReferral-Dashboard.vue'

</script>